import { VideoUploader } from "@api.video/video-uploader";
import { Observable } from "rxjs";
import { checkVideoAvailability, getCamitagFromId, mapCamitagAndVideoApi } from "../Repository/Api";
import { generateUploadToken, getBearerToken, updateVideoTitle } from "../Repository/ApiVideo";
import { startVideoCompression } from "./VideoCompressBusiness";

export function getVideoConstraints(cameraFront) {
    const audio = {
        echoCancellation: true
    };
    const videoQuality = {
        width: { ideal: 1280 },
        height: { ideal: 720 },
        frameRate: { ideal: 30 }
    };
    if (cameraFront == true) {
        return {
            audio,
            video: {
                facingMode: 'user',
                ...videoQuality
            }
        };

    }
    else if (cameraFront == false) {
        return {
            audio,
            video: {
                facingMode: 'environment',
                ...videoQuality
            }
        };
    }

    else {
        return {
            audio,
            video: videoQuality
        };
    }
};


export const identifyFacingModeSupport = () => {
    try {
        const supports = navigator.mediaDevices.getSupportedConstraints();
        // return false;
        return supports.facingMode;
        // if (!supports['facingMode']) {
        //   
        //     return false;
        // }    
    } catch (error) {
       

        return false;
    }

}

export function createMediaRecorder(stream) {
    const mimeType = getSupportedMedia();
    const options = {
        videoBitsPerSecond: 2500000,
        audioBitsPerSecond: 96000
    };
    if (mimeType) {
        options.mimeType = mimeType;
    }
    try {
        return new MediaRecorder(stream, options);
    } catch (error) {
        try {
            return new MediaRecorder(stream, mimeType ? { mimeType } : undefined);
        } catch (fallbackError) {
            return new MediaRecorder(stream);
        }
    }
}

export function requestMedia(_constraints = false) {
    return new Promise((resolve, reject) => {
        let CONSTRAINTS = (_constraints === false) ? getVideoConstraints() : _constraints;
        if (CONSTRAINTS && typeof CONSTRAINTS.video === "object" && CONSTRAINTS.video) {
            CONSTRAINTS = {
                ...CONSTRAINTS,
                video: {
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                    frameRate: { ideal: 30 },
                    ...CONSTRAINTS.video
                }
            };
        }
        let MIMETYPE = getSupportedMedia();
        if (MIMETYPE === false) {
            console.error("Media Recorder is not available in this Browser");
            reject({ type: 'exception', code: 'NULLMEDIARECORDER', message: 'Media recorder is not available in this Browser' });
        } else {
            const startRecorder = (stream) => {
                const MR = createMediaRecorder(stream);
                resolve({ type: 'success', code: 200, response: { streamObject: stream, mediaRecorder: MR } });
            };
            navigator.mediaDevices.getUserMedia(CONSTRAINTS)
                .then(startRecorder)
                .catch((error) => {
                    if (error && error.name === "OverconstrainedError") {
                        const fallbackVideo = CONSTRAINTS.video && CONSTRAINTS.video.facingMode
                            ? { facingMode: CONSTRAINTS.video.facingMode }
                            : true;
                        navigator.mediaDevices.getUserMedia({
                            audio: CONSTRAINTS.audio,
                            video: fallbackVideo
                        })
                            .then(startRecorder)
                            .catch((fallbackError) => {
                                reject({ type: 'exception', code: 'USERMEDIAERROR', message: 'User media exception', response: { errorObject: fallbackError } });
                            });
                        return;
                    }
                    reject({ type: 'exception', code: 'USERMEDIAERROR', message: 'User media exception', response: { errorObject: error } });
                });
        }
    });

}

export function getSupportedMedia() {
    if (!MediaRecorder) {
        return false;
    } else if (MediaRecorder.isTypeSupported("video/webm")) {
        return 'video/webm';
    } else if (MediaRecorder.isTypeSupported("video/mp4")) {
        return 'video/mp4';
    }
}

export let uploadRecordedVideoBusiness = (videoFile, videoName = "") => {
   
    return new Observable(observer => {
        (async () => {
            try {
                const displayName = String(videoName ?? "").trim();
                observer.next({ event: 'progressbar', progress: 0, phase: 'compressing' });
                const fileToUpload = await startVideoCompression(videoFile, (ratio) => {
                    observer.next({
                        event: 'progressbar',
                        progress: Math.round(Number(ratio) * 100),
                        phase: 'compressing'
                    });
                });

                observer.next({ event: 'progressbar', progress: 0, phase: 'uploading' });
                const delegate_token = await getUploadToken();
                const uploaderOptions = {
                    file: fileToUpload,
                    uploadToken: delegate_token,
                    retries: 10,
                    chunkSize: 10 * 1024 * 1024
                };
                if (displayName) {
                    uploaderOptions.videoName = displayName;
                }
                let uploader;
                try {
                    uploader = new VideoUploader(uploaderOptions);
                } catch {
                    uploader = new VideoUploader({
                        file: fileToUpload,
                        uploadToken: delegate_token,
                        retries: 10,
                        chunkSize: 10 * 1024 * 1024
                    });
                }

                uploader.onProgress((event) => {
                    const uploadedPerc = (Number(event.uploadedBytes) / Number(event.totalBytes)) * 100;
                    observer.next({
                        event: 'progressbar',
                        progress: uploadedPerc,
                        phase: 'uploading'
                    });
                });
                const video = await uploader.upload();
                if (displayName && video?.videoId) {
                    try {
                        const bearerToken = await getBearerToken();
                        await updateVideoTitle(bearerToken, video.videoId, displayName);
                    } catch {
                        /* list pages can still show the Cami row name for the latest clip */
                    }
                }
                observer.next({ event: 'progressbar', progress: 100, phase: 'uploading' });
                observer.next({ event: 'complete', response: video });
                observer.complete();
            } catch (error) {
                observer.next({ event: 'error', msg: error });
                observer.complete();
            }
        })();
    });
}

export let getCamitagFromUrl = () => {
    return getQueryParamValue(window.location, 'c');
}

export let getRecordingTimeFromUrl = () => {
    return getQueryParamValue(window.location, 't');
}

export const RECORDING_DURATION_SECONDS = 20 * 60;
export const RECORDING_DURATION_MS = RECORDING_DURATION_SECONDS * 1000;

export let getRecordingTimeFromLS = () => {
    return RECORDING_DURATION_MS;
}

export let getQueryParamValue = (url, paramName) => {
    try {
        const urlparams = new URLSearchParams(url.search);
        const _camitagid = urlparams.get(paramName) || "";
        return _camitagid;
    } catch (error) {
        return "";
    }
}

export let getUploadToken = () => {
    return new Promise((resolve, reject) => {
      
        getBearerToken()
            .then((res) => {
               
                if (res) {
                    generateUploadToken(res)
                        .then((tokenResult) => {
                            resolve(tokenResult['token']);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                } else {
                    reject({ msg: "Failed to fetch the bearer token" });
                }
            })
            .catch((err) => {
                reject({ msg: "Failed to fetch the bearer token", err: err });
            });
    })
}

export let getVideoAvailabilityStatus = (camitagId, password) => {
    return new Promise((resolve, reject) => {
        checkVideoAvailability(camitagId, password)
            .then((result) => {
                if (result['videoId'] || result['fileUrl']) {
                    resolve(formVCAResponse(result, 'ready'));
                } else {
                    result['camitag'] = camitagId;
                    resolve(formVCAResponse(result, 'navigate-camitagid'));
                }
            })
            .catch((err) => { });
    });
}

const formVCAResponse = (result, status) => {
    const _duration =result['duration'];
    console.log(result)
    if ( _duration == 29) {
        localStorage.setItem('RT','P1')
       
        // localStorage.removeItem('RT');
    } else if (_duration == 180 || _duration == 900 || _duration == 1200) {
      
        localStorage.setItem('RT','P2')
        // localStorage.removeItem('RT');
    }    
    let res = {};
    if (status === 'navigate-camitagid') {
        res['url'] = "/upload-video?c=" + result['camitag'] + '&p=mediaBusiness';
        res['status'] = status;
        res['camiTypeId']=result["camiTypeId"];
        res["foreverEmail"]=result["foreverEmail"];
    } else if (status === 'navigate-fresh') {
        res['url'] = "/qr-steps";
        res['status'] = status;
    } else {
        res = JSON.parse(JSON.stringify(result));
        res['status'] = status;
    }
   
    return res;
}

export let mapCamitagAndVideo = (data) => {
    return new Promise((resolve, reject) => {
        mapCamitagAndVideoApi(data)
            .then((res) => res.json())
            .then((result) => {
               
                let CAMICode = result.camiCode;
                let UniqueId = result.uniqueId;
              
                resolve({ "camiId": CAMICode, "camiPass": UniqueId });

            })
            .catch((error) => {
                reject(error);
            });

    });
}

export const downloadFile = url => window.open(url, '_blank');

const Exports = {
    getVideoConstraints,
    requestMedia,
    getSupportedMedia,
    requestMedia,
    uploadRecordedVideoBusiness,
    getCamitagFromUrl,
    getRecordingTimeFromUrl,
    getRecordingTimeFromLS,
    getQueryParamValue,
    getUploadToken,
    mapCamitagAndVideo,
    downloadFile
};
export default Exports;
